<template>
  <v-dialog
    v-model="messageModal"
    max-width="600"
  >
    <v-card>
      <v-card-title class="subheading">Сообщение</v-card-title>
      <v-card-text>
        <p>{{message}}</p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          flat="flat"
          @click="messageModal = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MessageModal',
  data () {
    return {
      messageModal: false,
      message: ''
    }
  },
  methods: {
    open (message) {
      this.message = message
      this.messageModal = true
    },
    close () {
      this.messageModal = false
    }
  }
}
</script>

<style scoped>

</style>
